"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shop = void 0;
var Shop;
(function (Shop) {
    Shop["minora"] = "minora";
    Shop["tw"] = "tw";
    Shop["cilorB2B"] = "cilorB2B";
    Shop["cilorB2C"] = "cilorB2C";
    Shop["schmuckwunder"] = "schmuckwunder";
})(Shop = exports.Shop || (exports.Shop = {}));
//# sourceMappingURL=Shop.js.map